<template>
  <div>
    <!-- 导航组件封装 -->
    <Navigation></Navigation>
    <div class="container-xl top"></div>
    <div class="container-xl">
      <div class="row periphery">
        <div class="col-lg-6">
          <div class="periphery-head1">
            <img v-if="toggle == 2" src="../img/Frame 66424.png" alt="" />
            <img v-if="toggle == 3" src="../img/Frame 70785.png" alt="" />
            <img v-if="toggle == 4" src="../img/Frame 70796.png" alt="" />
            <img v-if="toggle == 5" src="../img/Frame 70807.png" alt="" />
            <div class="periphery-head2">
              <img @click="ys(2)" src="../img/Frame 66424.png" alt="" />
              <img @click="ys(3)" src="../img/Frame 70785.png" alt="" />
              <img @click="ys(4)" src="../img/Frame 70796.png" alt="" />
              <img @click="ys(5)" src="../img/Frame 70807.png" alt="" />
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="toothbrush">
            <h2>
              {{ data.name }}
            </h2>
            <div class="price">
              <span>单价</span
              ><span>￥{{ data.money }}</span>
            </div>
            <img src="../img/Group 7071@2x.png" alt="" />
            <h4>
              <img src="../img/button icon66.png" alt="" />&nbsp;⼀个充电底座
            </h4>
            <h4>
              <img
                src="../img/button icon66.png"
                alt=""
              />&nbsp;两个be@meSonic™声波牙刷头
            </h4>
            <h4>
              <img src="../img/button icon66.png" alt="" />&nbsp;30天满意保证期
            </h4>
            <h4><img src="../img/button icon66.png" alt="" />&nbsp;免费送货</h4>
            <h4>
              <img src="../img/button icon66.png" alt="" />&nbsp;⼀年保养期
            </h4>
            <p class="periphery-head-p">
              感受be@meSonic™星际声波牙刷的⼒量和新鲜感。
              be@meSonic™声波震动牙刷将会为你带来每天令⼈满意的微笑。
            </p>
            <div class="icon">
              <img src="../img/填充图标_支付_银行卡@2x.png" alt="" />
              <img src="../img/填充图标_支付_银行卡@2x.png" alt="" />
            </div>
            <el-button
              onClick=" fbq ( 'track' , 'Pay' )"
              type="text"
              @click="dialogTableVisible = true"
              >立刻购买<img src="../img/jinan1.png" alt="" />
            </el-button>
            <el-dialog :visible.sync="dialogTableVisible">
              <div class="pen">
                <img src="../img/Shopping cart@2x.png" alt="" />
                <h2>be@me声波电动牙刷</h2>
              </div>
              <div class="data">
                <van-field
                  v-model="userName"
                  label="姓名"
                  placeholder="请输入用户名"
                />

                <van-field
                  v-model="userPhone"
                  type="tel"
                  label="手机号"
                  placeholder="请输入手机号"
                />
                <van-field
                  v-model="mail"
                  label="邮箱"
                  placeholder="请输入邮箱"
                />
                <van-field
                  v-model="address"
                  label="地址"
                  placeholder="请输入地址"
                />
                <button @click="kap1()">去付款</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <div class="container-xl">
      <div class="row introduce">
        <div class="col-lg-6 picture">
          <img src="../img/Frame 66428.png" alt="" />
        </div>
        <div class="col-lg-6 Features">
          <img src="../img/Frame.png" alt="" />
          <h2>
            beameSonic ™声波震动牙刷， 全球独家专利技术每分钟四万八千次，
            High-Tech。
          </h2>
          <van-collapse
            style="text-align: left; margin-top: 30px"
            v-model="activeName"
            accordion
          >
            <van-collapse-item title="超高速,强震动" name="1">
              <div style="margin-bottom: 10px">
                beameSonic™声波电动牙刷是市场声波震动频率最高的牙刷。每分钟能发出高达48000次声波震动，比普通电动牙刷的速度快14倍。有了beameSonic™，你可以更安全有效地清洁牙齿，而不只是传统轻轻地清洁牙齿的表面。现在立刻使用beameSonic™星际声波牙刷，为你的牙齿带来健康美白的未来！
              </div>
            </van-collapse-item>
            <van-collapse-item title="独特之处" name="2"
              ><div style="margin-bottom: 10px">
                be@meSonic™星际声波牙刷具有3种不同的模式可满足用家的需求-日常洁净模式、温和清洁模式和强度美白模式。
                经过专业牙医验证，最佳刷牙时间为2分钟，be@meSonic™星际声波电动牙刷在达到2分钟后会自动停止。而be@meSonic™在电池电量不足时也会提前通知，我们更提供usb充电底座，确保您的be@meSonic™带来无穷无尽的洁齿体验。
              </div>
            </van-collapse-item>
            <van-collapse-item title="盒子里面有什么" name="3"
              ><div style="margin-bottom: 10px">
                ⼀个be@meSonic星际声波电动牙刷机身<br />
                ⼀个be@meSonic充电底座<br />
                两个be@meSonic专属牙刷头<br /></div
            ></van-collapse-item>
            <van-collapse-item title="刷头订购计划" name="4"
              ><div style="margin-bottom: 10px">
                我们的牙医建议您每3个月定期更换牙刷头，以获得最佳的⼝腔卫⽣清洁体验。可另外选购be@meSonic™特级柔软刷头3件装。
              </div></van-collapse-item
            >
            <van-collapse-item title="我们的承诺" name="5"
              ><div style="margin-bottom: 10px">
                be@meSonic™ 声波震动牙刷享用一年保养期。 <br />
                若在妥善按照指引使用产品的情况下出现问题，我们将为你办理退换。
              </div></van-collapse-item
            >
          </van-collapse>
        </div>
      </div>
    </div>
    <div class="container-xl">
      <div class="row Advantage">
        <h2>be@meSonic 星际声波牙刷优势</h2>
        <div class="col-lg-3">
          <div class="illustrate">
            <img src="../img/Frame 6796@2x.png" alt="" />
            <h4>IPX7级防水</h4>
            <p>
              全身可水洗，可在水下冲洗，沐浴<br />使用也不怕，随意浸泡，滴水不入。
            </p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="illustrate">
            <img src="../img/Frame 6796_1@2x.png" alt="" />
            <h4>牙医推荐</h4>
            <p>根据调研，be@meSonic™星际<br />声波电动牙刷获得众多牙医推荐。</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="illustrate">
            <img src="../img/Frame 6796_2@2x.png" alt="" />
            <h4>时尚美观</h4>
            <p>匠心工艺，亲肤手感，双层外<br />壳，7道喷漆手感工艺。</p>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="illustrate">
            <img src="../img/Frame 6795@2x.png" alt="" />
            <h4>深层洁牙</h4>
            <p>
              全球独家专利技术，每分钟能高<br />达48000次声波震动，比普通电<br />动牙刷的速度快14倍。
            </p>
          </div>
        </div>
        <el-button class="Buy" type="text" @click="dialogTableVisible = true"
          >立刻购买<img src="../img/jinan1.png" alt="" />
        </el-button>
      </div>
    </div>
    <!-- 底部组件封装 -->
    <Bottom></Bottom>
  </div>
</template>
<script>
import { pay, commodity } from "@/api/outpatient";
import Navigation from "@/components/Navigation.vue";
import Bottom from "@/components/Bottom.vue";
export default {
  metaInfo: {
    link: [
      {
        rel: "canonical",
        href: "https://mybeame.com/periphery",
      },
      {
        rel: "alternate",
        href: "https://mybeame.com/periphery",
        hrefLang: "x-default",
      },
    ],
  },
  components: {
    Navigation,
    Bottom,
  },
  data() {
    return {
      userName: "",
      userPhone: "",
      mail: "",
      address: "",
      replace: 1,
      activeName: "1", //默认打开第一个折叠面板
      toggle: "2",
      commodityId: "1",
      uresData: {},
      data: {},
      dialogTableVisible: false,
      value: "",
    };
  },
  mounted() {
    this.replace = JSON.parse(localStorage.getItem("Screen"));
    //获取商品信息
    commodity().then((res) => {
      this.data = res.data;
    });
  },
  methods: {
    //点击切换图片事件
    ys(a) {
      this.toggle = a;
    },
    //验证信息 发送购买请求
    kap1: function () {
      if (this.userName == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning",
        });
        return;
      }



      if (/^[0-9]\d{4,10}$/.test(this.userPhone) == false) {
        this.$message({
          message: "手机号格式不正确",
          type: "warning",
        });
        return;
      }

      if (this.mail == "") {
        this.$message({
          message: "邮箱格式不正确",
          type: "warning",
        });
        return;
      }

      this.subData = Object.assign(this.uresData);
      var uresData = {
        name: this.userName,
        phone: this.value + this.userPhone,
        mail: this.mail,
        address: this.address,
        commodityId: this.commodityId,
      };
      pay(uresData).then((res) => {
        if (res.code == 200) {
          location.href = res.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.container-xl {
  padding: 0;
}

.row {
  margin-left: 0;
  margin-right: 0;
}
.top {
  padding-top: 70px;
}
.periphery {
  padding: 50px 0;
  background-color: #f2f2f2;
}
.periphery-head1 > img {
  width: 100%;
}
.periphery-head2 {
  text-align: center;
}
.periphery-head2 > img {
  width: 60px;
  height: 60px;
  cursor: pointer;
  border-radius: 50%;
  margin: 40px 10px 30px 10px;
}
.toothbrush {
  margin-left: 5%;
}
.toothbrush > h2 {
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 10px;
}
.price span:nth-child(2) {
  margin: 0 20px 0 5px;
  font-size: 34px;
}
.toothbrush > img {
  width: 90%;
  margin: 15px 0;
}
.toothbrush > h4 {
  font-size: 21px;
  font-weight: 600;
  margin-bottom: 10px;
}
.toothbrush > h4 > img {
  width: 24px;
  height: 24px;
}
.icon > img {
  width: 33px;
  height: 33px;
  margin-right: 15px;
}
.el-button {
  width: 80%;
  height: 70px;
  border: none;
  margin-top: 25px;
  float: left;
  font-size: 23px;
  font-weight: 600;
  color: #323e48 !important;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 30px 0px 0px;
}
.pen {
  text-align: center;
}
.pen > img {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}
.pen > h2 {
  font-size: 36px;
  font-weight: 600;
}
.data {
  text-align: center;
}
.van-cell {
  width: 55%;
  border: 2px solid #00e467;
  border-radius: 10px;
  margin: auto;
  margin-top: 30px;
}
.area {
  width: 55%;
  height: 48px;
  padding-left: 2%;
  background-color: #fff;
  border-radius: 10px;
  margin: auto;
  margin-top: 30px;
  border: 2px solid #00e467;
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  color: #323e48;
}
.area >>> .el-input {
  width: 80%;
}
.data > button {
  width: 50%;
  height: 50px;
  font-size: 18px;
  border: 2px;
  cursor: pointer;
  font-weight: 600;
  margin: 45px 0 20px 0px;
  color: rgb(10, 10, 10);
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 10px 0px 0px;
  box-shadow: 0px 0px 6px 0px rgba(42, 59, 77, 0.2);
}
.introduce {
  padding: 50px 0;
}
.picture {
  text-align: center;
  padding: 20px 0;
}
.picture > img {
  width: 75%;
}
.Features > img {
  margin-top: 50px;
}
.Features > h2 {
  font-size: 30px;
  margin-top: 10px;
  font-weight: 600;
}
.van-collapse >>> .van-collapse-item__content {
  font-size: 16px !important;
}
.Advantage {
  padding: 20px 0;
  margin-bottom: 50px;
  border-radius: 0 0 250px 0;
  background-image: url(../img/Frame68651.png);
}
.Advantage > h2 {
  font-size: 48px;
  font-weight: 700;
  margin-top: 50px;
  text-align: center;
  margin-bottom: 80px;
}
.illustrate {
  text-align: center;
}
.illustrate > img {
  width: 45%;
  margin-bottom: 15px;
}
.illustrate > h4 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}
.Buy {
  width: 30%;
  height: 70px;
  border: none;
  margin: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  font-size: 23px;
  font-weight: 600;
  color: #323e48 !important;
  background: linear-gradient(90deg, #36ff94 0%, #00e467 100%);
  border-radius: 0px 30px 0px 0px;
}
.van-collapse-item {
  border-bottom: 1px solid #00e467;
}

h1,
h2,
h3,
h4,
h5,
button,
a {
  font-family: "chinaGenSenMaruGothicTW-Bold";
}

p,
span,
div {
  font-family: "chinaGenSenMaruGothicTW-Regular";
}
@media all and (max-width: 992px) {
  .picture > img {
    width: 95%;
  }
  .van-cell {
    width: 60%;
  }
  .area {
    width: 60%;
  }
  .illustrate > img {
    width: 30%;
  }
  .Advantage {
    background-image: none;
    background-color: #f2f2f2;
    border-radius: 0;
    margin-bottom: 0;
  }
}
@media all and (max-width: 770px) {
  .picture > img {
    width: 100%;
  }

  .toothbrush > h2 {
    font-size: 35px;
  }
  .price span:nth-child(2) {
    font-size: 27px;
  }
  .Advantage > h2 {
    font-size: 37px;
  }
  .illustrate > img {
    width: 30%;
  }
  .Buy {
    width: 60%;
  }
  .van-cell {
    width: 75%;
  }
  .area {
    width: 75%;
  }
  .pen > h2 {
    font-size: 29px;
  }
}
@media all and (max-width: 570px) {
  .row > * {
    padding-left: 0px;
    padding-right: 0px;
  }
  .top {
    padding-top: 46px;
  }
  .toothbrush > h2 {
    font-size: 27px;
  }
  .toothbrush > h4 {
    font-size: 19px;
  }
  .price span:nth-child(2) {
    font-size: 22px;
  }
  .el-button {
    width: 95%;
    height: 50px;
    margin-top: 25px;
    margin-bottom: 30px;
    border-radius: 0px;
    font-size: 21px;
  }
  .periphery {
    padding: 0;
    background-color: #fff;
  }
  .picture > img {
    width: 100%;
  }
  .introduce {
    text-align: center;
  }
  .Features > img {
    margin-top: 0px;
  }
  .Features > h2 {
    font-size: 21px;
    padding: 0 5%;
  }
  .van-collapse >>> .van-cell {
    font-size: 17px !important;
  }
  .van-collapse-item__content > div {
    font-size: 15px;
  }
  .Advantage {
    background-image: none;
    background-color: #f2f2f2;
    border-radius: 0;
    margin-bottom: 0;
  }
  .Advantage > h2 {
    padding: 0 5%;
    font-size: 29px;
  }
  .illustrate > img {
    width: 35%;
  }
  .el-dialog__wrapper >>> .el-dialog {
    width: 95% !important;
  }
  .van-cell {
    width: 90%;
  }
  .area {
    width: 90%;
  }
  .data > button {
    width: 70%;
  }
  .pen > h2 {
    font-size: 25px;
  }
}
</style>